import type { ComponentChildren, JSX } from 'preact';

interface CardProps {
  children: ComponentChildren;
  className?: string;
  onClick?: () => void;
  style?: JSX.CSSProperties;
}

export function Card({ children, className, onClick, style }: CardProps) {
  return (
    <div
      class={`card${className ? ` ${className}` : ''}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
}
